import React, { Fragment, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Card,
  CardBody,
  CardTitle,
  Badge,
  CardImg,
  Button,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import {
  gAPI_TicketsRecording_id,
  postAPI_Ticket_SendText,
  postAPI_Create_QuickReply,
  gAPI_QuickReplyDelete_ById,
  postAPI_DownloadMedia,
  aPI_Contacts,
  API_Chat_Logs,
} from '../../constants/APIs';
import { AxiosAPI, getGroupID, getUserRole } from '../../helpers/AxiosAPI';
import IntlMessages from '../../helpers/IntlMessages';
import moment from 'moment';
import phone_suite_domain from './../../assets/phone_suite_domain.png';
import called_party from './../../assets/called_party.png';
import phone_suite_call_icon from './../../assets/phone_suite_call_icon.png';
import phone_suite_calling_party from './../../assets/phone_suite_calling_party.png';
import { Colxx } from '../../components/common/CustomBootstrap';
import { NotificationManager } from '../../components/common/react-notifications';
//import QuickReplyList from '../../views/app/pages/tickets/components/QuickReplyList';
import Select from 'react-select';
import MessageTemplateForm from './MessageTemplateForm';
import UpdateMessageTemplateForm from './UpdateMessageTemplateForm';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../helpers/Utils';
import Masking from '../../data/Masking';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faSms } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLock,
  faLockOpen,
  faCheck,
  faCopy,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons';
import ChatLogs from './ChatLogs';
const Visitor = ({
  item,
  //twilioMakingConnection,
  toggle,
  StopFacebookChat,
  ResumeFacebookChat,
  recordingurl,
  transcript,
  quickReplyTemplates,
  propertyId,
  loadQuickTemmplates,
  //statustoggle,
  handleMaskClick,
  isMasked,
  clickedLinks,
  handleStatusSubmit,
  hideButtons = false,
  conversationSummary,
}) => {
  const [isFBChatStop, setFBChatStop] = useState(item.transferToFaceBook);
  const [templateVisible, setTemplateVisible] = useState(false);
  const [blobUrl, setBlobUrl] = useState('');
  const [ApiState, setApiState] = useState('default');
  const [contact, setContact] = useState();
  const [chatLogsData, setChatLogsData] = useState([]);
  const [showChatLogs, setShowChatLogs] = useState(false);
  useEffect(() => {
    setBlobUrl('');
    setApiState('default');
    setChatLogsData([]);
    let body = {
      name: getVisitorName(item?.channel),
      email: getVisitorEmail(item?.channel),
      phone: getVisitorPhone(item?.channel),
      channel:
        item.channel === 'FacebookDirectLine' ||
        item.channel === 'TeamsApp' ||
        item.channel === 'WhatsApp' ||
        item.channel === 'Sms' ||
        item.channel === 'PhoneSuite'
          ? 'SocialMedia'
          : '',
    };
    if (body?.name !== '' || body?.email !== '' || body?.phone !== '') {
      AxiosAPI({
        method: 'POST',
        url: `${aPI_Contacts}/find`,
        data: body,
      }).then((res) => {
        if (res.data && res.data?.contactId) {
          if (res.data.contactId !== '00000000-0000-0000-0000-000000000000')
            setContact(res.data.contactId);
        }
      });
    }
  }, [item]);

  const getVisitorName = (channel) => {
    if (channel === 'TeamsApp') return item?.visitor?.teamSender;
    else if (channel === 'WhatsApp') return item?.visitor?.whatsAppSenderName;
    else if (channel === 'FacebookDirectLine')
      return item?.visitor?.facebookSenderName;
    else if (channel === 'PhoneSuite') return '';
    else return item?.visitor?.name;
  };

  const getVisitorPhone = (channel) => {
    if (channel === 'TeamsApp') return item?.visitor?.teamSenderId;
    else if (channel === 'WhatsApp')
      return item?.visitor?.whatsAppSenderPhoneNumber;
    else if (channel === 'Sms') return item?.visitor?.smsSenderPhoneNumber;
    else if (channel === 'FacebookDirectLine')
      return item?.visitor?.facebookSenderId;
    else if (channel === 'PhoneSuite') return item?.visitor?.accountDomain;
    else return item?.visitor?.phoneNumber;
  };

  const getVisitorEmail = (channel) => {
    if (channel === 'TeamsApp') return '';
    else if (channel === 'WhatsApp') return '';
    else if (channel === 'Sms') return '';
    else if (channel === 'FacebookDirectLine') return '';
    else if (channel === 'PhoneSuite') return '';
    else return item?.visitor?.email;
  };

  const handleSubmit = (data) => {
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_QuickReply}`,
      data,
    })
      .then((m) => {
        loadQuickTemmplates();
        setTemplateVisible(!templateVisible);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const fbStop = (botConversationId) => {
    StopFacebookChat(botConversationId);
    setFBChatStop(true);
  };
  const fbResume = (botConversationId) => {
    ResumeFacebookChat(botConversationId);
    setFBChatStop(false);
  };
  const handleChangeSelect = (e) => {
    const reply = quickReplyTemplates.filter((m) => m.id === e.value);
    setMessageContent(reply[0].message);
  };
  const [visible, setVisible] = useState(false);
  const [qrVisible, setQRVisible] = useState(false);
  const [messageContent, setMessageContent] = useState('');

  const toggleModal = () => {
    setVisible(!visible);
  };
  const toggleQR = () => {
    setQRVisible(!qrVisible);
  };
  const handleChange = (e) => {
    setMessageContent(e.target.value);
  };
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  const badgeColors = [
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'danger',
    'light',
    'dark',
  ];
  const getBadgeColor = (key) => {
    if (!key) return 'primary';
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = (hash << 5) - hash + key.charCodeAt(i);
      hash |= 0;
    }
    return badgeColors[Math.abs(hash) % badgeColors.length];
  };
  const getChatLogs = async (conversationId) => {
    try {
      const response = await AxiosAPI({
        method: 'get',
        url: `${API_Chat_Logs}?conversationId=${conversationId}`,
      });
      setChatLogsData(response.data);
    } catch (error) {
      console.error('Failed to fetch chat logs:', error);
    }
  };
  const openChatLogs = (conversationId) => {
    getChatLogs(conversationId);
    setShowChatLogs(true);
  };
  const deleteReply = (id) => {
    let data = {
      Deleter: 'dashboard',
    };

    AxiosAPI({
      method: 'put',
      url: `${gAPI_QuickReplyDelete_ById}/${id}`,
      data,
    }).then(
      (res) => {
        loadQuickTemmplates();
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleSendTextSubmit = () => {
    let data = {
      message: messageContent,
      recipent: item.visitor.phoneNumber,
    };

    AxiosAPI({
      method: 'post',
      url: `${postAPI_Ticket_SendText}`,
      data,
    }).then(
      (res) => {
        toggle();
        NotificationManager.success(
          '',
          'Message sent.',
          3000,
          null,
          null,
          'success'
        );
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleChangeStatus = (val) => {
    handleStatusSubmit(val);
  };

  const playStream = (streamId, startedUtc) => {
    setApiState('processing');
    AxiosAPI({
      method: 'post',
      url: `${postAPI_DownloadMedia}`,
      data: {
        container:
          'recordings/' +
          moment.utc(startedUtc).format('YYYY') +
          '/' +
          moment.utc(startedUtc).format('MM') +
          '/' +
          moment.utc(startedUtc).format('DD') +
          '/',
        fileName: streamId + '.wav',
      },
    }).then(
      (res) => {
        if (res.data?.content && res.data.content != null) {
          const base64String = `data:audio/wav;base64,${res.data.content}`;
          const base64Data = base64String.split(',')[1]; // Remove "data:audio/wav;base64," prefix
          const binaryString = atob(base64Data); // Decode base64 to binary string
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          const arrayBuffer = bytes.buffer;
          let blob = new Blob([arrayBuffer], {
            type: 'audio/wav',
          });
          let downloadUrl = window.URL.createObjectURL(blob);
          setBlobUrl(downloadUrl);
          setApiState('success');
          // const audio = new Audio(downloadUrl)
          // console.log(audio)
          // audio.load()
          // audio.play()
        }
      },
      (error) => {
        setApiState('fail');
        console.log(error);
      }
    );
  };
  const copyToClipboard = (text) => {
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          NotificationManager.success('', 'Copied to clipboard.', 2000);
        })
        .catch(() => {
          NotificationManager.error('', 'Failed to copy.', 3000);
        });
    } else {
      try {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        NotificationManager.success('', 'Copied to clipboard.', 2000);
      } catch (e) {
        NotificationManager.error('', 'Failed to copy.', 3000);
      }
    }
  };
  const handleConactRedirect = () => {
    if (contact !== undefined)
      window.location.href = '/app/pages/contact-details/' + contact;
  };
  return (
    <div className="scroll cardHeight visitor  conversation-height archive-card">
      {hideButtons !== undefined && hideButtons == true ? null : (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle> </CardTitle>
              {item.takeControl === true &&
              item.visitor.facebookSenderId !== '' ? (
                <Fragment>
                  <Button
                    color="primary"
                    outline
                    onClick={toggle}
                    style={{ borderRadius: '6px' }}
                    className="mr-1 mb-1"
                  >
                    <IntlMessages id="Convert to Ticket" />
                  </Button>

                  {!isFBChatStop ? (
                    <Button
                      color="primary"
                      outline
                      onClick={() => fbStop(item.botConversationId)}
                      style={{ borderRadius: '6px' }}
                      className="mr-1 mb-1"
                    >
                      Handover to Messenger
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      outline
                      onClick={() => fbResume(item.botConversationId)}
                      style={{ borderRadius: '6px' }}
                      className="mr-1 mb-1"
                    >
                      Handover to Chatbot
                    </Button>
                  )}
                </Fragment>
              ) : null}

              <Fragment>
                <Button
                  color="primary"
                  outline
                  onClick={toggle}
                  style={{ borderRadius: '6px' }}
                  className="mr-1 mb-1"
                >
                  <IntlMessages id="Convert to Ticket" />
                </Button>
                {item.status === 'Opened' ? (
                  <Button
                    color="success"
                    onClick={() => handleChangeStatus('Closed')}
                    style={{ borderRadius: '6px' }}
                    className="mr-1 mb-1"
                  >
                    <FontAwesomeIcon icon={faCheck} className="fa mr-2" />
                    Mark Closed
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    onClick={() => handleChangeStatus('Opened')}
                    style={{ borderRadius: '6px' }}
                    className="mr-1 mb-1"
                  >
                    <i className="iconsminds-right-1"></i> Mark Open
                  </Button>
                )}
                {/* <Button
                color="primary"
                outline
                onClick={() => statustoggle()}
                style={{ borderRadius: '6px' }}
                className="mr-1 mb-1"
              >
                {item.status === 'Opened' ? 'Change Ticket Status' : item.status}
              </Button> */}
              </Fragment>
            </CardBody>
          </Card>
        </div>
      )}
      {item.channel !== 'PhoneSuite' && (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle>
                <IntlMessages id="content.chatinsights" />{' '}
              </CardTitle>
              <div className="d-flex flex-row pb-1">
                <div className="pl-3 pr-2">
                  <p className="mb-0 ">
                    <i className="demo-icon iconsminds-clock"></i>
                  </p>
                </div>
                <div className="pl-3 pr-2">
                  <p className="mb-0">
                    {item.visitor.contactId !== undefined &&
                    item.visitor.contactId !== '' ? (
                      <Fragment>
                        {' '}
                        {moment(item.startedUtc).format(
                          'dddd, DD MMMM YYYY'
                        )}{' '}
                        at {moment(item.startedUtc).format('h:mm a')}
                      </Fragment>
                    ) : (
                      <Fragment>
                        {' '}
                        {moment(item.startedUtc).format(
                          'dddd, DD MMMM YYYY'
                        )}{' '}
                        at {moment(item.startedUtc).format('h:mm a')}
                      </Fragment>
                    )}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-row pb-1">
                <div className="pl-3 pr-2">
                  <p className="mb-0 ">
                    <i className="demo-icon iconsminds-books"></i>
                  </p>
                </div>
                <div className="pl-3 pr-2">
                  {item.tags.map((tag, index) => {
                    return (
                      <Fragment>
                        {' '}
                        <Badge color={generateRandomColor()}>{tag}</Badge>{' '}
                      </Fragment>
                    );
                  })}
                </div>
              </div>
              {item.visitor.ipAddress !== '' &&
              item.visitor.ipAddress !== null ? (
                <Fragment>
                  <div className="d-flex flex-row pb-1">
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <i className="demo-icon iconsminds-map-marker-2"></i>
                      </p>
                    </div>
                    <div className="pl-3 pr-2">
                      {item.visitor.ipAddress !== '' ? (
                        <p className="mb-0 ">
                          <IntlMessages id="dashboards.near" />{' '}
                          {item.visitor.location}{' '}
                        </p>
                      ) : null}
                      {item.visitor.ipAddress !== '' ? (
                        <p className="mb-0 text-semi-muted ">
                          This location is approximate and determined by IP
                          address ({item.visitor.ipAddress})
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {item.visitor.latitude !== undefined &&
                    item.visitor.latitude !== '' && (
                      <div className="d-flex flex-row pb-1">
                        <iframe
                          width="100%"
                          height="170"
                          frameBorder="0"
                          scrolling="no"
                          marginHeight="0"
                          marginWidth="0"
                          src={`https://maps.google.com/maps?q=${item.visitor.latitude},${item.visitor.longitude}&hl=es&z=14&output=embed`}
                        ></iframe>
                      </div>
                    )}
                </Fragment>
              ) : null}
            </CardBody>
          </Card>
        </div>
      )}
      {((item.visitor.name !== null && item.visitor.name !== '') ||
        (item.visitor.email !== null && item.visitor.email !== '') ||
        (item.visitor.teamSender !== null && item.visitor.teamSender !== '') ||
        (item.visitor.phoneNumber !== null &&
          item.visitor.phoneNumber !== '') ||
        (item.channel !== 'Phone' &&
          item.visitor.consentGivenDateTime !== '' &&
          item.visitor.consentGivenDateTime !== null)) && (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle>
                <IntlMessages id="content.prechatinfo" />{' '}
                <i
                  className="simple-icon-action-redo"
                  style={{ cursor: 'pointer' }}
                  onClick={handleConactRedirect}
                ></i>
              </CardTitle>
              {item.visitor.name !== null && item.visitor.name !== '' && (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-administrator"> </i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">{item.visitor.name}</p>
                  </div>
                </div>
              )}
              {item.visitor.teamSender !== '' && (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-administrator"> </i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">{item.visitor.teamSender}</p>
                  </div>
                </div>
              )}
              {item.visitor.email !== null && item.visitor.email !== '' && (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-at-sign"> </i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      {isMasked !== 'true' ? (
                        <Masking
                          input={item.visitor.email}
                          inputType={'email'}
                        ></Masking>
                      ) : (
                        item.visitor.email
                      )}
                      <span
                        className="text-muted ml-1"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleMaskClick()}
                      >
                        <FontAwesomeIcon
                          icon={isMasked === 'true' ? faLock : faLockOpen}
                          className="fa"
                        />
                      </span>
                    </p>
                  </div>
                </div>
              )}
              {item.visitor.phoneNumber !== null &&
                item.visitor.phoneNumber !== '' && (
                  <div className="d-flex flex-row pb-1">
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <i className="demo-icon iconsminds-smartphone-4"> </i>
                      </p>
                    </div>
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        {isMasked !== 'true' ? (
                          <Masking
                            input={item.visitor.phoneNumber}
                            inputType={'mobile'}
                            number={4}
                          ></Masking>
                        ) : (
                          item.visitor.phoneNumber
                        )}
                        <span
                          className="text-muted ml-1"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleMaskClick()}
                        >
                          <FontAwesomeIcon
                            icon={isMasked === 'true' ? faLock : faLockOpen}
                            className="fa"
                          />
                        </span>
                      </p>
                    </div>
                  </div>
                )}

              {item.visitor.zipCode !== null && item.visitor.zipCode !== '' && (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-post-mail"> </i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">{item.visitor.zipCode}</p>
                  </div>
                </div>
              )}
              {item.channel !== 'Phone' &&
                item.visitor.consentGivenDateTime !== '' &&
                item.visitor.consentGivenDateTime !== null && (
                  <div className="d-flex flex-row pb-1">
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <i className="demo-icon iconsminds-handshake"> </i>
                      </p>
                    </div>
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <IntlMessages id="dashboards.marketingconsent" />:
                        {item.visitor.consentGiven === 'Yes' ? (
                          <span style={{ color: 'green', marginLeft: '5px' }}>
                            {item.visitor.consentGiven}
                          </span>
                        ) : (
                          <span style={{ color: 'red', marginLeft: '5px' }}>
                            {item.visitor.consentGiven}
                          </span>
                        )}{' '}
                        (
                        {moment(item.visitor.consentGivenDateTime).format(
                          'dddd, DD MMMM YYYY'
                        )}{' '}
                        {moment(item.visitor.consentGivenDateTime).format(
                          'h:mm a'
                        )}
                        )
                      </p>
                    </div>
                  </div>
                )}
            </CardBody>
          </Card>
        </div>
      )}
      {item.visitor.additionalInfo !== undefined &&
        item.visitor.additionalInfo !== null && (
          <Fragment>
            {(item.visitor.additionalInfo.groupName !== null &&
              item.visitor.additionalInfo.groupName !== '') ||
            (item.visitor.additionalInfo.businessName !== null &&
              item.visitor.additionalInfo.businessName !== '') ||
            (item.visitor.additionalInfo.propertyName !== null &&
              item.visitor.additionalInfo.propertyName !== '') ||
            (item.visitor.additionalInfo.chainName !== null &&
              item.visitor.additionalInfo.chainName !== '') ||
            (item.visitor.additionalInfo.userType !== null &&
              item.visitor.additionalInfo.userType !== '') ? (
              <Fragment>
                <div className="icon-row-item mb-4">
                  <Card>
                    <CardBody>
                      <CardTitle>
                        Additional Pre-chat Info{' '}
                        <i
                          className="simple-icon-action-redo"
                          style={{ cursor: 'pointer' }}
                          onClick={handleConactRedirect}
                        ></i>
                      </CardTitle>
                      {item.visitor.additionalInfo.groupName !== null &&
                        item.visitor.additionalInfo.groupName !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-business-man-woman">
                                  {' '}
                                </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.groupName}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.businessName !== null &&
                        item.visitor.additionalInfo.businessName !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-chrysler-building">
                                  {' '}
                                </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.businessName}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.propertyName !== null &&
                        item.visitor.additionalInfo.propertyName !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-building">
                                  {' '}
                                </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.propertyName}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.chainName !== null &&
                        item.visitor.additionalInfo.chainName !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-solar"> </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.chainName}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.userType !== null &&
                        item.visitor.additionalInfo.userType !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-user"> </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.userType}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.accountId !== undefined &&
                        item.visitor.additionalInfo.accountId !== null &&
                        item.visitor.additionalInfo.accountId !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-id-card">
                                  {' '}
                                </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.accountId}
                              </p>
                            </div>
                          </div>
                        )}
                      {item.visitor.additionalInfo.contactId !== undefined &&
                        item.visitor.additionalInfo.contactId !== null &&
                        item.visitor.additionalInfo.contactId !== '' && (
                          <div className="d-flex flex-row pb-1">
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                <i className="demo-icon iconsminds-business-man-woman">
                                  {' '}
                                </i>
                              </p>
                            </div>
                            <div className="pl-3 pr-2">
                              <p className="mb-0 ">
                                {item.visitor.additionalInfo.contactId}
                              </p>
                            </div>
                          </div>
                        )}
                    </CardBody>
                  </Card>
                </div>
              </Fragment>
            ) : null}
          </Fragment>
        )}
      {((item.channel !== 'PhoneSuite' &&
        item.visitor.whatsAppSenderPhoneNumber === '' &&
        item.visitor.smsSenderPhoneNumber === '' &&
        item.visitor.url !== '' &&
        item.visitor.url !== null) ||
        (item.visitor.referralUrl !== '' &&
          item.visitor.referralUrl !== null)) && (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle>
                <IntlMessages id="content.visitedpages" />{' '}
              </CardTitle>
              {item.visitor.url !== '' && item.visitor.url !== null && (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-link"></i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 text-semi-muted ">
                      <IntlMessages id="content.chatstartedonthispage" />
                    </p>
                    <p className="mb-0 ">{item.visitor.url}</p>
                  </div>
                </div>
              )}

              {item.visitor.referralUrl !== '' &&
              item.visitor.referralUrl !== null ? (
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-link"></i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 text-semi-muted ">
                      User referred to your page by this website
                    </p>
                    <p className="mb-0 ">{item.visitor.referralUrl}</p>
                  </div>
                </div>
              ) : null}
            </CardBody>
          </Card>
        </div>
      )}
      {item.channel === 'PhoneSuite' ? (
        <Fragment>
          <div className="icon-row-item mb-4">
            <Card>
              <CardBody>
                <CardTitle>
                  {' '}
                  <IntlMessages id="content.callinfo" />{' '}
                </CardTitle>
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2" style={{ width: '7%' }}>
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-clock"></i>
                    </p>
                  </div>
                  <div className="pl-3 pr-1">
                    <p className="mb-0 text-semi-muted ">
                      {' '}
                      <IntlMessages id="content.timestamp" />:
                    </p>
                  </div>
                  <div className="pr-2">
                    <p className="mb-0">
                      {item.visitor.contactId !== undefined &&
                      item.visitor.contactId !== '' ? (
                        <Fragment>
                          {moment(item.startedUtc).format('dddd, DD MMMM YYYY')}{' '}
                          at {moment(item.startedUtc).format('h:mm a')}
                        </Fragment>
                      ) : (
                        <Fragment>
                          {moment(item.startedUtc).format('dddd, DD MMMM YYYY')}{' '}
                          at {moment(item.startedUtc).format('h:mm a')}
                        </Fragment>
                      )}
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-row pb-1">
                  <div className="pl-3 pr-2" style={{ width: '7%' }}>
                    <p className="mb-0 ">
                      <i className="demo-icon iconsminds-books"></i>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    <p className="mb-0 ">
                      <p className="mb-0 text-semi-muted ">
                        <IntlMessages id="content.topics" />:
                      </p>
                    </p>
                  </div>
                  <div className="pl-3 pr-2">
                    {item.tags !== undefined &&
                    item.tags != null &&
                    item.tags.length > 0 ? (
                      <Fragment>
                        {item.tags.map((tag, index) => {
                          return (
                            <Fragment>
                              {' '}
                              <Badge color={generateRandomColor()}>
                                {tag}
                              </Badge>{' '}
                            </Fragment>
                          );
                        })}
                      </Fragment>
                    ) : (
                      <Fragment>
                        {conversationSummary &&
                        conversationSummary?.topics_discussed &&
                        conversationSummary?.topics_discussed.length > 0
                          ? conversationSummary?.topics_discussed.map(
                              (tag, index) => {
                                return (
                                  <Fragment key={index}>
                                    {' '}
                                    <Badge color={generateRandomColor()}>
                                      {tag}
                                    </Badge>{' '}
                                  </Fragment>
                                );
                              }
                            )
                          : null}
                      </Fragment>
                    )}
                  </div>
                </div>

                {item.visitor.nmsAni !== '' && item.visitor.nmsAni !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <img
                            src={phone_suite_calling_party}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            <IntlMessages id="content.callingparty" />:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.nmsAni}</p>
                      </div>
                      <div className="pr-2">
                        <i
                          className="simple-icon-action-redo"
                          style={{ cursor: 'pointer' }}
                          onClick={handleConactRedirect}
                        ></i>
                      </div>
                    </div>
                  </Fragment>
                ) : null}

                {item.visitor.accountUser !== '' &&
                item.visitor.accountUser !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <i className="demo-icon iconsminds-user"></i>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted">
                            <IntlMessages id="dashboards.calling_party" />:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.accountUser}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {item.visitor.accountDomain !== '' &&
                item.visitor.accountDomain !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <img
                            src={called_party}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            <IntlMessages id="content.calledparty" />:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.accountDomain}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {item.visitor.accountDomain !== '' &&
                item.visitor.accountDomain !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <img
                            src={phone_suite_domain}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            {/* <IntlMessages id="content.accountdomain" />:{' '} */}
                            Voice AI Number:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.accountDomain}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}

                {/* {item.visitor.nmsDnis !== '' &&
                  item.visitor.nmsDnis !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <img
                            src={called_party}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            Called Party:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.nmsDnis}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null} */}
                {item.visitor.toUser !== '' && item.visitor.toUser !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <i className="demo-icon iconsminds-user"></i>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            <IntlMessages id="dashboards.called_party" /> :{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.toUser}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {item.visitor.forwardNumber !== '' &&
                item.visitor.forwardNumber !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2" style={{ width: '7%' }}>
                        <p className="mb-0 ">
                          <img
                            src={phone_suite_calling_party}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            {/* <IntlMessages id="content.forwardNumber" />:{' '} */}
                            Forwarded To:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.forwardNumber}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {item.visitor.toDomain !== '' &&
                item.visitor.toDomain !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <img
                            src={phone_suite_domain}
                            style={{ height: '1rem' }}
                          ></img>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            Called Party Domain:{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.toDomain}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}

                {item.visitor.accountLastDial !== '' &&
                item.visitor.accountLastDial !== null ? (
                  <Fragment>
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <p className="mb-0 text-semi-muted ">
                            {' '}
                            <IntlMessages id="dashboards.lastdial" /> :{' '}
                          </p>
                        </p>
                      </div>
                      <div className="pr-2">
                        <p className="mb-0 ">{item.visitor.accountLastDial}</p>
                      </div>
                    </div>
                  </Fragment>
                ) : null}
              </CardBody>
            </Card>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          {((item.visitor.facebookSenderId === '' &&
            item.visitor.googleSenderName === '' &&
            item.visitor.instagramSenderId === '' &&
            item.visitor.whatsAppSenderPhoneNumber === '' &&
            item.visitor.smsSenderPhoneNumber === '') ||
            (item.visitor.facebookSenderId !== '' &&
              item.visitor.facebookSenderId !== null) ||
            (item.visitor.googleSenderName !== '' &&
              item.visitor.googleSenderName !== null) ||
            (item.visitor.whatsAppSenderPhoneNumber !== null &&
              item.visitor.whatsAppSenderPhoneNumber !== '') ||
            (item.visitor.smsSenderPhoneNumber !== null &&
              item.visitor.smsSenderPhoneNumber !== '') ||
            (item.visitor.instagramSenderId !== '' &&
              item.visitor.instagramSenderId !== null)) && (
            <div className="icon-row-item mb-4">
              <Card>
                <CardBody>
                  <CardTitle>
                    <IntlMessages id="content.deviceinfo" />
                  </CardTitle>
                  {item.visitor.facebookSenderId === '' &&
                  item.visitor.instagramSenderId === '' &&
                  item.visitor.googleSenderName === '' ? (
                    <Fragment>
                      {item.channel !== 'WhatsApp' &&
                        item.channel !== 'Sms' && (
                          <Fragment>
                            <div className="d-flex flex-row pb-1">
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  <i className="demo-icon iconsminds-computer">
                                    {' '}
                                  </i>
                                </p>
                              </div>
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  {item.visitor.deviceType}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex flex-row pb-1">
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  {' '}
                                  <i className="demo-icon iconsminds-optimization"></i>
                                </p>
                              </div>
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  {item.visitor.browser} browser
                                </p>
                              </div>
                            </div>
                            <div className="d-flex flex-row pb-1">
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  <i className="demo-icon iconsminds-user"></i>
                                </p>
                              </div>
                              <div className="pl-3 pr-2">
                                <p className="mb-0 ">
                                  {item.visitor.userAgent}
                                </p>
                              </div>
                            </div>
                          </Fragment>
                        )}
                    </Fragment>
                  ) : null}
                  {item.visitor.facebookSenderId !== '' &&
                  item.visitor.facebookSenderId !== null ? (
                    <Fragment>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <i className="demo-icon iconsminds-id-card"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 text-semi-muted ">
                            Facebook Sender Id
                          </p>
                          <p className="mb-0 ">
                            {' '}
                            {item.visitor.facebookSenderId}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {' '}
                            <i className="demo-icon iconsminds-facebook"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {item.visitor.facebookSenderName}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <i className="demo-icon iconsminds-user"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <CardImg
                              top
                              src={item.visitor.facebookProfilePic}
                              alt="Card image cap"
                              className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                  {item.visitor.googleSenderName !== '' &&
                  item.visitor.googleSenderName !== null ? (
                    <Fragment>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {' '}
                            <i className="demo-icon simple-icon-social-google"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {item.visitor.googleSenderName}
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                  {item.visitor.whatsAppSenderPhoneNumber !== '' &&
                  item.visitor.whatsAppSenderPhoneNumber !== null ? (
                    <Fragment>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 text-muted">
                            <FontAwesomeIcon
                              icon={faWhatsapp}
                              className="fa ml-1"
                            />
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p
                            className="mb-0 text-semi-muted"
                            style={{ marginLeft: '3px' }}
                          >
                            What'sApp Phone Number
                            <span className="pr-2">
                              <i
                                className="simple-icon-action-redo"
                                style={{ cursor: 'pointer' }}
                                onClick={handleConactRedirect}
                              ></i>
                            </span>
                          </p>
                          <p className="mb-0" style={{ marginLeft: '3px' }}>
                            {' '}
                            {item.visitor.whatsAppSenderPhoneNumber}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {' '}
                            <i className="demo-icon iconsminds-administrator"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {item.visitor.whatsAppSenderName}
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                  {item.visitor.instagramSenderId !== '' &&
                  item.visitor.instagramSenderId !== null ? (
                    <Fragment>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <i className="demo-icon iconsminds-id-card"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 text-semi-muted ">
                            Instagram Sender Id
                          </p>
                          <p className="mb-0 ">
                            {' '}
                            {item.visitor.instagramSenderId}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {' '}
                            <i className="demo-icon iconsminds-facebook"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {item.visitor.instagramSenderName}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <i className="demo-icon iconsminds-user"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            <CardImg
                              top
                              src={item.visitor.instagramSenderProfilePic}
                              alt="Card image cap"
                              className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                          </p>
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                  {item.channel === 'Sms' &&
                  item.visitor.smsSenderPhoneNumber !== '' &&
                  item.visitor.smsSenderPhoneNumber !== null ? (
                    <Fragment>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 text-muted">
                            <FontAwesomeIcon icon={faSms} className="fa ml-1" />
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p
                            className="mb-0 text-semi-muted"
                            style={{ marginLeft: '3px' }}
                          >
                            Sms Phone Number
                            <span className="pr-2">
                              <i
                                className="simple-icon-action-redo"
                                style={{ cursor: 'pointer' }}
                                onClick={handleConactRedirect}
                              ></i>
                            </span>
                          </p>
                          <p className="mb-0" style={{ marginLeft: '3px' }}>
                            {' '}
                            {item.visitor.smsSenderPhoneNumber}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-row pb-1">
                        <div className="pl-3 pr-2">
                          <p className="mb-0 ">
                            {' '}
                            <i className="demo-icon iconsminds-administrator"></i>
                          </p>
                        </div>
                        <div className="pl-3 pr-2">
                          <p className="mb-0 "></p>
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                </CardBody>
              </Card>
            </div>
          )}{' '}
        </Fragment>
      )}
      {((recordingurl !== '' && recordingurl !== undefined) ||
        (transcript !== '' && transcript !== undefined) ||
        (item.visitor.phoneNumber !== '' &&
          item.channel === 'Phone' &&
          item.visitor.phoneNumber !== undefined)) && (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle>
                <IntlMessages id="content.recording&transcript" />{' '}
              </CardTitle>
              {recordingurl !== '' && (
                <Row>
                  <Colxx xxs="12">
                    <audio
                      src={recordingurl}
                      controls
                      style={{ width: '100%' }}
                    ></audio>
                  </Colxx>
                </Row>
              )}
              {transcript !== '' && (
                <Fragment>
                  <div className="d-flex ticket-info-requester-title">
                    Customer Transcript
                  </div>
                  <Row>
                    <Colxx xxs="12">
                      <Input
                        type="textarea"
                        name="transcript"
                        value={transcript}
                      />
                    </Colxx>
                  </Row>
                </Fragment>
              )}
              {item.visitor.phoneNumber !== '' &&
                item.channel === 'Phone' &&
                item.visitor.phoneNumber !== undefined &&
                (item.visitor.phoneNumber.startsWith('+6422') ||
                  item.visitor.phoneNumber.startsWith('+6427') ||
                  item.visitor.phoneNumber.startsWith('+6421') ||
                  item.visitor.phoneNumber.startsWith('+6428') ||
                  item.visitor.phoneNumber.startsWith('+6429')) && (
                  <Fragment>
                    <Row className="mt-3">
                      <Colxx xxs="12">
                        <Button
                          color="primary"
                          className="default mb-2"
                          onClick={() => toggleModal()}
                          style={{ width: '50%' }}
                        >
                          Send a Text
                        </Button>
                      </Colxx>
                    </Row>
                  </Fragment>
                )}
              {item.visitor.phoneNumber !== '' &&
                item.channel === 'Phone' &&
                item.visitor.phoneNumber !== undefined && (
                  <Fragment>
                    <Row className="mt-3">
                      <Colxx xxs="12">
                        <Button
                          color="primary"
                          disabled={true}
                          className="default mb-2"
                          style={{ width: '50%' }}
                        >
                          <IntlMessages id="content.callback" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Fragment>
                )}
            </CardBody>
          </Card>
        </div>
      )}
      {item.streamId !== '' && (
        <div className="icon-row-item mb-4">
          <Card>
            <CardBody>
              <CardTitle>
                <IntlMessages id="content.recording" />{' '}
              </CardTitle>
              {blobUrl === '' && (
                // <Button
                //   color="primary"
                //   className="default mb-2"
                //   style={{ width: '100%' }}
                //   onClick={() => playStream(item.streamId, item.integrationId)}
                // >
                //   Play
                // </Button>
                <Button
                  color="primary"
                  size="xs"
                  onClick={() => playStream(item.streamId, item.startedUtc)}
                  className={`btn-multiple-state ${classnames({
                    'show-spinner': ApiState === 'processing',
                    'show-success': ApiState === 'success',
                    'show-fail': ApiState === 'fail',
                  })}`}
                >
                  <span className="spinner d-inline-block">
                    <span className="bounce1" />
                    <span className="bounce2" />
                    <span className="bounce3" />
                  </span>
                  <span className="icon success">
                    <i className="simple-icon-check" />
                  </span>
                  <span className="icon fail">
                    <i className="simple-icon-exclamation" />
                  </span>
                  <span className="label">
                    {' '}
                    <FontAwesomeIcon
                      icon={faPlayCircle}
                      className="fa ml-1"
                    />{' '}
                    Play
                  </span>
                </Button>
              )}
              {blobUrl !== '' && (
                <Row>
                  <Colxx xxs="12">
                    <audio
                      src={blobUrl}
                      controls
                      autoPlay={true}
                      style={{ width: '100%' }}
                    ></audio>
                  </Colxx>
                </Row>
              )}
            </CardBody>
          </Card>
        </div>
      )}
      {clickedLinks !== undefined && clickedLinks.length > 0 && (
        <Card>
          <CardBody>
            <CardTitle>Clicked Links</CardTitle>
            <div className="d-flex flex-row pb-1">
              <div className=" pr-2" style={{ paddingLeft: '2.5rem' }}>
                <ul>
                  {clickedLinks.map((m) => (
                    <li>{m}</li>
                  ))}
                </ul>
              </div>
            </div>
          </CardBody>
        </Card>
      )}
      {getUserRole() !== 'Agent' && getUserRole() !== 'NA' ? (
        <Button
          className="ml-3"
          size="xs"
          color="primary"
          outline
          onClick={() => openChatLogs(item.botConversationId)}
        >
          View Logs
        </Button>
      ) : null}
      <ChatLogs
        isOpen={showChatLogs}
        toggle={() => setShowChatLogs(false)}
        chatLogs={chatLogsData}
        conversationId={item.botConversationId}
      />
      <div className="mt-2 d-flex flex-row pb-1">
        <div className="pl-3 pr-2">
          <p className="mb-0 ">
            <i className="demo-icon iconsminds-speach-bubble"></i>
          </p>
        </div>
        <div className="pl-3 pr-2">
          <p className="mb-0 text-semi-muted ">
            {item.channel === 'PhoneSuite' ? (
              <IntlMessages id="content.phonesystemoriginationcallid" />
            ) : (
              <IntlMessages id="content.uniqueChatId" />
            )}
          </p>
          <p className="mb-0 ">{item.conversationId}</p>
        </div>
      </div>
      <div className="mt-2 d-flex flex-row pb-1">
        <div className="pl-3 pr-2">
          <p className="mb-0 ">
            <i className="demo-icon iconsminds-speach-bubble"></i>
          </p>
        </div>
        <div className="pl-3 pr-2">
          <p className="mb-0 text-semi-muted ">
            {item.channel === 'PhoneSuite' ? (
              <IntlMessages id="content.phonesystemterminationcallid" />
            ) : (
              <IntlMessages id="content.uniqueConversationId" />
            )}
          </p>
          <p className="mb-0 ">{item.botConversationId}</p>
        </div>
      </div>
      {item.channel === 'PhoneSuite' && (
        <Fragment>
          {/* <div className="mt-4 d-flex flex-row pb-1">
          <div className="pl-3 pr-2">
            <p className="mb-0 ">
              <img src={phone_suite_call_icon} style={{ height: '1rem' }}></img>
            </p>
          </div>
          <div className="pl-3 pr-2">
            <p className="mb-0 text-semi-muted ">Myma.ai Unique Chat ID</p>
            <p className="mb-0 ">{item.visitor.origCallID}</p>
          </div>
        </div> */}
          <div className="mt-2 d-flex flex-row pb-1">
            <div className="pl-3 pr-2">
              <p className="mb-0 ">
                <img
                  src={phone_suite_call_icon}
                  style={{ height: '1rem' }}
                ></img>
              </p>
            </div>
            <div className="pl-3 pr-2">
              <p className="mb-0 text-semi-muted ">
                <IntlMessages id="content.uniqueConversationId" />{' '}
              </p>
              <p className="mb-0 ">{item.visitor.termCallID}</p>
            </div>
          </div>
        </Fragment>
      )}

      {item.salesforceCaseNumber !== undefined &&
        item.salesforceCaseNumber !== null &&
        item.salesforceCaseNumber.length > 0 && (
          <div className="mt-2 d-flex flex-row pb-1">
            <div className="pl-3 pr-2">
              <p className="mb-0 text-muted">
                <FontAwesomeIcon icon={faPaperclip} className="fa" />
              </p>
            </div>
            <div className="pl-3 pr-2">
              <p className="mb-0 text-semi-muted ">Salesforce Case</p>
              <p className="mb-0 ">
                {item.salesforceCaseNumber.map((c, idx) => {
                  return (
                    <Fragment key={idx}>
                      <Badge color={getBadgeColor(c)} className="mr-1">
                        {c}
                      </Badge>
                      <FontAwesomeIcon
                        icon={faCopy}
                        className="fa ml-1 mr-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => copyToClipboard(c)}
                      />
                    </Fragment>
                  );
                })}
              </p>
            </div>
          </div>
        )}

      <Row>
        <Colxx xxs="12">
          <Modal isOpen={visible} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>
              Pick a quick reply or type your message
            </ModalHeader>
            <ModalBody>
              <Row className="mb-2">
                <Colxx xxs="12">
                  <Button
                    color="primary"
                    className="mb-2"
                    outline
                    size="lg"
                    style={{ width: '100%', borderRadius: '6px' }}
                    onClick={toggleQR}
                  >
                    View Templates
                  </Button>
                </Colxx>
              </Row>
              <Row>
                <Colxx xxs="12">
                  <Row className="mb-2">
                    <Colxx xxs="3">
                      <label>Message</label>
                    </Colxx>
                    <Colxx xxs="9">
                      <Input
                        name="ticketMessage"
                        onChange={handleChange}
                        type="textarea"
                        value={messageContent}
                      />
                    </Colxx>
                  </Row>
                  <Row className="mb-2">
                    <Colxx xxs="3">
                      <label>Quick Replies</label>
                    </Colxx>
                    <Colxx xxs="9">
                      <Select
                        className="react-select"
                        classNamePrefix="react-select"
                        name="id"
                        isMulti={false}
                        onChange={handleChangeSelect}
                        options={
                          quickReplyTemplates
                            ? reactSelectOptionDiffrentPro(
                                quickReplyTemplates,
                                true,
                                'id',
                                'name',
                                'All Templates'
                              )
                            : []
                        }
                      />
                    </Colxx>
                  </Row>
                  <Row>
                    <Colxx xxs="3">
                      <Button
                        color="primary"
                        className="mb-2"
                        onClick={handleSendTextSubmit}
                      >
                        <IntlMessages id="forms.submit" />
                      </Button>
                    </Colxx>
                  </Row>
                </Colxx>
              </Row>
            </ModalBody>
          </Modal>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <Modal isOpen={qrVisible} toggle={toggleQR} size="lg">
            <ModalHeader toggle={toggleQR}>Templates</ModalHeader>
            <ModalBody>
              <Row className="survey-app">
                <Colxx xxs="12">
                  <div className="mb-2">
                    <div>
                      <Button
                        color="primary"
                        outline
                        size="lg"
                        style={{ width: '100%', borderRadius: '6px' }}
                        onClick={() => {
                          setTemplateVisible(!templateVisible);
                        }}
                      >
                        + Create a New Template
                      </Button>
                    </div>
                    <MessageTemplateForm
                      formLabel="Create a New Message"
                      visible={templateVisible}
                      toggle={() => {
                        setTemplateVisible(!templateVisible);
                      }}
                      submit={handleSubmit}
                      propertyId={propertyId}
                    />
                  </div>
                </Colxx>
              </Row>
              {quickReplyTemplates.map((item, index) => {
                return (
                  <Colxx xxs="12">
                    <Card className="d-flex flex-row mb-3">
                      <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                        <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                          <p className="mb-1  text-small w-15 w-sm-100">
                            <b>{item.name}</b>
                          </p>
                          <div className="w-15 w-sm-100">
                            <UpdateMessageTemplateForm
                              id={item.id}
                              propertyId={propertyId}
                              loadQuickTemmplates={loadQuickTemmplates}
                            />
                          </div>
                          <div className="w-15 w-sm-100">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => deleteReply(item.id)}
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Colxx>
                );
              })}
            </ModalBody>
          </Modal>
        </Colxx>
      </Row>
    </div>
  );
};
export default React.memo(Visitor);
